import { State } from 'store';

export default function getInputsFormData(state: State) {
  return state.startWorkflow.steps.provideInputs.formData;
}
